<template>
  <div class="container mt-3">
    <h2>Languages</h2>
    <div class="alert alert-danger" style="text-align: center">
      <h6 style="margin-bottom: 0;">
        !!!Please create a
        <router-link to="/backups" 
                     class="alert-link">snapshot</router-link>BEFORE performing any changes to the database!!!
      </h6>
    </div>
    <div
      class="col-xs-12 col-sm-8 col-md-6 offset-sm-3 offset-md-3 text-center">
      <p v-if="errorMessage" class="mb-3">{{ errorMessage }}</p>
    </div>
    <div
      class="col-xs-12 col-sm-8 col-md-6 offset-sm-3 offset-md-3 text-center">
      <form @submit.prevent="addLanguage()">
        <div class="row">
          <div class="col-md-6">
            <input
              id="language"
              v-model="language"
              type="text"
              name="language"
              required
              class="form-control form-control-sm"
              placeholder="Language">
          </div>
          <div class="col-md-2">
            <input
              id="name"
              v-model="name"
              type="text"
              name="name"
              required
              class="form-control form-control-sm"
              placeholder="Code">
          </div>
          <div class="col-md-4 text-left">
            <button
              type="submit"
              class="btn btn-sm btn-primary submit-btn">
              {{ button.text }}
            </button>
          </div>
        </div>
      </form>
      <div class="row bg-light">
        <div class="col-md-6 text-left text-bold p-2">Name</div>
        <div class="col-md-2 p-2">Code</div>
        <div class="col-md-4"/>
      </div>
      <div
        v-for="language in languages"
        :key="language.id"
        class="row">
        <div class="col-md-6 text-left">{{ language.language }}</div>
        <div class="col-md-2">{{ language.name }}</div>
        <div class="col-md-4">
          <a
            class="btn btn-sm m-1 btn-outline-primary"
            @click.stop="editLanguage(language)">Edit</a>
          <a
            class="btn btn-sm btn-outline-danger"
            @click.stop="deleteLanguage(language)">Delete</a>
        </div>
      </div>
    </div>
    <modal-confirm
      v-if="showModal"
      :msg="deleteMessage"
      :action="confirmAction"
      :action-name="confirmActionName"
      @close="showModal = false"/>
  </div>
</template>

<script>
import 'firebase/firestore';
import ModalConfirm from '../components/ModalConfirm.vue';
import EventBus from '../services/eventBus';
import {
	db,
	languagesCollection,
	translationsCollection,
} from '../services/firebaseConfig';

export default {
	name: 'ListLanguages',
	components: {
		ModalConfirm,
		EventBus,
	},
	data() {
		return {
			language: '',
			name: '',
			id: '',
			languages: [],
			errorMessage: '',
			deleteMessage: '',
			confirmAction: 'confirmDelete',
			confirmActionName: 'Delete',
			button: {
				text: 'Add',
			},
			showModal: false,
			languageToBeDeleted: {
				language: '',
			},
		};
	},
	created() {
		// firebase utils
		languagesCollection
			.orderBy('language')
			.get()
			.then((querySnapShot) => {
				querySnapShot.forEach((doc) => {
					const data = {
						id: doc.id,
						language: doc.data().language,
						name: doc.data().name,
					};
					this.languages.push(data);
				});
			});
	},
	mounted() {
		EventBus.$on('confirmDelete', () => {
			this.confirmDelete();
		});
	},
	beforeDestroy() {
		EventBus.$off('confirmDelete');
	},
	methods: {
		addLanguage() {
			this.errorMessage = '';
			// firebase utils
			if (this.id === '') {
				let isLanguageExists = this.languages.filter((eachLng) => {
					return (
						eachLng.name === this.name ||
						eachLng.language.toLowerCase() ===
							this.language.toLowerCase()
					);
				});

				if (isLanguageExists.length > 0) {
					this.errorMessage = 'Error: Language already exists';
					return;
				}
				
				languagesCollection
					.add({
						language: this.language,
						name: this.name,
					})
					.then((docRef) => {
						const data = {
							id: docRef.id,
							language: this.language,
							name: this.name,
						};
						this.languages.push(data);
						this.reset();
					})
					.catch((error) => {
						this.errorMessage = error;
					});
			} else {
				const docRef = languagesCollection.doc(this.id);
				docRef
					.update({
						language: this.language,
						name: this.name,
					})
					.then(() => {
						for (var i in this.languages) {
							if (this.languages[i].id === this.id) {
								const data = {
									id: docRef.id,
									language: this.language,
									name: this.name,
								};
								this.languages[i] = data;
								this.reset();
								break;
							}
						}
					})
					.catch((error) => {
						this.errorMessage = error;
					});
			}

			this.button.text = 'Add';
		},
		editLanguage(obj) {
			this.errorMessage = '';
			this.language = obj.language;
			this.name = obj.name;
			this.id = obj.id;
			this.button.text = 'Update';
		},
		deleteLanguage(language) {
			this.deleteMessage =
				'Are you sure want to delete ' + language.language;
			this.languageToBeDeleted = language;
			this.showModal = true;
		},
		confirmDelete() {
			var _self = this;
			const payLoad = this.languageToBeDeleted;
			languagesCollection
				.doc(payLoad.id)
				.delete()
				.then(() => {
					_self.languages = _self.languages.filter((item) => {
						return item.id !== payLoad.id;
					});

					// delete translations
					var docRef = languagesCollection.doc(
						_self.languageToBeDeleted.id
					);

					var tranRef = translationsCollection.where(
						'language',
						'==',
						docRef
					);
					let batch = db.batch();

					tranRef.get().then((snapshot) => {
						snapshot.docs.forEach((doc) => {
							batch.delete(doc.ref);
						});
						return batch.commit();
					});
				})
				.catch((error) => {
					this.errorMessage = error;
				});
			this.showModal = false;
		},
		reset() {
			this.id = '';
			this.language = '';
			this.name = '';
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/ListLanguages.vue